<div class="cardLayout">
  <ion-row>
    <ion-col size="8">
      <div class="formLabelSemiBoldfs16 mb-5">
        {{ operation === 'Edit' ? 'Edit' : 'Add' }}
      </div>
    </ion-col>
    <ion-col size="4" class="text-right">
      <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
    </ion-col>
  </ion-row>
    <ion-row>
      <ion-col size-sm="12" size-md="3" size-lg="6" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs14 mb-5">Select Employees<span class="red-cl">&nbsp;*</span></div>
        <ng-multiselect-dropdown class="w-70 mr-5 d-flex" [placeholder]="'Select Employee'" [settings]="dropdownSettings"
        [data]="getAllUsersList" [(ngModel)]="selectedEmployee" (onSelectAll)="selectAllEmployee($event)"
          (onDeSelectAll)="onDeSelectAllEmployee()"></ng-multiselect-dropdown>
        <label class="fs-12 red-cl font_regular"
          *ngIf="addSubmitForm && selectedEmployee.length==0">Employee is required</label>
      </ion-col>
      <ion-col size-sm="12" size-md="3" size-lg="6" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs14 mb-5">Select Months<span class="red-cl">&nbsp;*</span></div>
        <ng-multiselect-dropdown class="w-70 mr-5 d-flex" [placeholder]="'Select Months'" [settings]="dropdownSettings"
        [data]="getAllFutureMonthList" [(ngModel)]="selectedMonths" (onSelectAll)="selectAllMonths($event)"
          (onDeSelectAll)="onDeSelectAllMonths()"></ng-multiselect-dropdown>
          <label class="fs-12 red-cl font_regular"
          *ngIf="addSubmitForm && selectedMonths.length==0">Month is required</label>
      </ion-col>
      <ion-col size-sm="12" size-md="3" size-lg="6" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs14 mb-5">Select Day<span class="red-cl">&nbsp;*</span></div>
        <div *ngIf="operation == 'Edit'" class="inputBox notAllowed w-70">{{selectedDay}}</div>
        <ng-select *ngIf="operation != 'Edit'" class="w-70 d-flex" placeholder="Select Day" [(ngModel)]="selectedDay" (change)="chnageSelectedDay()">
          <ng-option *ngFor="let item of numbersOfDaysArray" [value]="item">{{item}}</ng-option>
        </ng-select>
        <label class="fs-12 red-cl font_regular"
          *ngIf="addSubmitForm && selectedDay==null">Day is required</label>
      </ion-col>
      <ion-col size-sm="12" size-md="3" size-lg="6" size-xs="12" class="mt-10">
        <div class="formLabelRegularfs14 mb-5">Relock Date</div>
        <div class="inputBox notAllowed w-70">{{relockDate | date: 'dd-MM-yyyy'}}</div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10">
        <button type="button" class="add_btn fs-14 fs_12ForMobile mr-15" [style.background-color]="buttonColorName"
        (click)="addPmsUnlockStatus()">
          Add New</button>
      </ion-col>
    </ion-row>
  <div class="clear20"></div>
</div>